<script>
export default {
  name: "UnlockInfinityDimButton",
  data() {
    return {
      isVisible: false,
      canUnlock: false,
      hasIPUnlock: true,
      amRequirement: new Decimal(0),
      ipRequirement: 0,
    };
  },
  computed: {
    text() {
      const dimensionText = `a new ${this.hasIPUnlock ? "type of Dimension" : "Infinity Dimension"}`;
      if (this.canUnlock) {
        if (this.amRequirement.eq("1e10500") && !PlayerProgress.eternityUnlocked())
          return `Unlock ${dimensionText} and The Mirror.`;
        return `Unlock ${dimensionText}.`;
      }
      const amDisplay = format(this.amRequirement);
      const ipDisplay = format(this.ipRequirement);
      if (this.hasIPUnlock) {
        return `Reach ${ipDisplay} Infinity Points and ${amDisplay} antimatter to unlock ${dimensionText}.`;
      }
      if (this.amRequirement.eq("1e10500") && !PlayerProgress.eternityUnlocked())
        return `Reach ${amDisplay} antimatter to unlock ${dimensionText} and The Mirror.`;
      return `Reach ${amDisplay} antimatter to unlock ${dimensionText}.`;
    },
    buttonClassObject() {
      return {
        "o-prestige-button": true,
        "o-infinity-button": true,
        "o-infinity-button--unavailable": !this.canUnlock,
      };
    },
  },
  methods: {
    update() {
      this.isVisible =
        player.break &&
        !InfinityDimension(8).isUnlocked &&
        !Player.canEternity &&
        !EternityMilestone.autoUnlockID.isReached;
      if (!this.isVisible) return;
      const nextDimension = InfinityDimensions.next();
      this.canUnlock = nextDimension.canUnlock;
      this.hasIPUnlock = nextDimension.hasIPUnlock;
      this.amRequirement = nextDimension.amRequirement;
      this.ipRequirement = nextDimension.ipRequirement;
    },
    tryUnlockNextInfinityDimension() {
      if (isSCRunningOnTierOrHigher(6, 1))
        return GameUI.notify.error(
          `Manually unlocking ID is disabled in SC6 (use "Buy Infinity Dimensions" command instead)`
        );
      InfinityDimensions.unlockNext();
    },
  },
};
</script>

<template>
  <button v-if="isVisible" :class="buttonClassObject" @click="tryUnlockNextInfinityDimension">
    {{ text }}
  </button>
</template>

<style scoped></style>

